// src/apiService.js

import axiosClient from './axiosClient'; // Import the Axios client

// Function to fetch vehicles
const getVehiclesTypes = async () => {
    try {
        const response = await axiosClient.get('/vehicles-type'); // API call
        return response.data; // Return the data from the response
    } catch (error) {
        console.error('Error fetching vehicles:', error);
        throw error; // Rethrow the error for further handling
    }
};

const getVehiclesTypeDetail = async (id) => {
    try {
        const response = await axiosClient.get(`/vehicles-type/${id}`); // API call
        return response.data; // Return the data from the response
    } catch (error) {
        console.error('Error fetching vehicles:', error);
        throw error; // Rethrow the error for further handling
    }
};

const createVehiclesType = async (formData) => {
    try {
        const response = await axiosClient.post('/vehicles-type', formData, {
            headers: {
                'Content-Type': 'multipart/form-data', // For file uploads
            },
        });
        return response.data; // Return the response data
    } catch (error) {
        console.error('Error creating vehicle:', error);
        throw error; // Rethrow error for handling in the component
    }
};

// DELETE vehicle by ID
const deleteVehiclesType = async (id) => {
    try {
        const response = await axiosClient.delete(`/vehicles-type/${id}`);
        return response.data; // Return the response data
    } catch (error) {
        console.error('Error deleting vehicle:', error);
        throw error; // Rethrow error for handling in the component
    }
};

// PATCH vehicle by ID
const updateVehiclesType = async (id, formData) => {
    try {
        const response = await axiosClient.patch(`/vehicles-type/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data', // For file uploads
            },
        });
        return response.data; // Return the response data
    } catch (error) {
        console.error('Error updating vehicle:', error);
        throw error; // Rethrow error for handling in the component
    }
};

// Export the function
export { getVehiclesTypes, deleteVehiclesType, createVehiclesType, updateVehiclesType, getVehiclesTypeDetail };
